// extracted by mini-css-extract-plugin
export default {"section":"settings_section__HZSZ1","settingsTitle":"settings_settingsTitle__b4cAw","settingsFlex":"settings_settingsFlex__4oWoy"};